import customers from "../services/customer.whitelist";
import notification from "../services/notification";
import { stat } from "fs";

export default {
    namespaced: true,

    state: {
        error: false,
        errors: {},
        whitelisted: [],
        whitelistType: null,
        currentPage: 1,
        nextPage: 0,
        prevPage: 0,
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        importfile: null,
        importBase: null,
        import: false,
        loading: false,
        perPage: 10,
        prevPage: null,
        nextPage: null,
        maxPage: null,
        uploading: null,
        deleteuuid: null
    },

    mutations: {
        setWhitelisted(state, response) {
            state.whitelisted = response;
        },

        setWhitelistType(state, response) {
            state.whitelistType = response;
        },

        whitelistPagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = state.totalPerPage > 0 ? pagination.max_page : 0;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.totalPerPage > 0
                    ? state.initialPageCount * state.prevPage + 1
                    : 0;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },

        setImportWhitelist(state, importfile) {
            state.importfile = importfile;
        },

        setImportWhitelistBase(state, importBase) {
            state.importBase = importBase;
            state.import = true;
        },

        loading(state, value) {
            state.loading = value;
        },

        errors(state, errors) {
            state.error = true;
            state.errors = errors.errors;
            state.loading = false;
        },

        setErrorDefault(state) {
            state.error = false;
            state.errors = {};
            state.loading = false;
        },

        setImportWhitelistBaseDefault(state) {
            state.importBase = null;
            state.import = false;
        },

        setUploadLoading(state, value) {
            state.uploading = value;
        },

        setDeleteUUID(state, uuid) {
            state.deleteuuid = uuid;
        },
        
        resetDeleteUUID(state) {
            state.deleteuuid = null;
        },

        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        },

        setCurrentPage(state, page) {
            state.currentPage = page;
        }
    },

    actions: {
        getWhitelist: async ({ commit, state }, page) => {
            commit("loading", true);
            try {
                let response = await customers.getWhitelist(
                    page
                );
                let whitelist = "";
                let whitelisted = [];
                let list = response.list;
                if (page == 1) {
                    await commit("setInitialPageCount", response.list);
                }
                if(list.length > 0) {
                    list.forEach(function(value){
                        whitelist = {
                            whitelist: value.hasOwnProperty("email")
                                ? value["email"]
                                : value.hasOwnProperty("mobile_number")
                                    ? value["mobile_number"]
                                    : value.hasOwnProperty("membership_id")
                                        ? value["membership_id"]
                                        : null,
                            status: value.status,
                            uuid: value.uuid
                        }
                        whitelisted.push(whitelist);
                    });
                }
                await commit("setWhitelisted", whitelisted);
                await commit("whitelistPagination", response);
                await commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
            }
        },

        getWhitelistType: async ({ commit }) => {
            commit("loading", true);
            try {
                let response = await customers.getWhitelistType();
                if (response.length > 0) {
                    response.forEach(function(value){
                        if(value.code === "whitelist") {
                            commit("setWhitelistType", value.type)
                        }
                    });
                }
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
            }
        },

        importWhitelist: async ({ commit, state }) => {
            commit("setUploadLoading", true);
            try {
                let response = await customers.importWhitelist({
                    csv: state.importBase
                });
                let status = response.stats;
                if(status["success"] !== 0 && status["invalid"] === 0 && status["duplication"] === 0) {
                    notification.success(response.message);
                } else {
                    notification.warning(status["success"] + " Uploaded </br>" + status["invalid"] + " Invalid </br>" + status["duplication"] + " Duplicate");
                }
                commit("setImportWhitelistBaseDefault");
                commit("setUploadLoading", false);
            } catch (errors) {
                    commit("loading", false);
                    commit("setUploadLoading", false);
                    commit("errors", errors);
                    notification.warning(errors);
                }
            },

        readImportWhitelist: async ({ commit, state, dispatch }) => {
            commit("loading");

            let reader = new FileReader();
            reader.readAsDataURL(state.importfile);

            reader.onload = e => {
                commit("setImportWhitelistBase", e.target.result.split("base64,").pop());
            };
        },

        deleteWhitelist: async ({ commit, state }) => {
            commit("loading", true);
            let list = state.whitelisted.length;
            try {
                let response = await customers.deleteWhitelist(state.deleteuuid);
                await commit("resetDeleteUUID");
                await commit("loading", false);
                if(list === 1) {
                    await commit("setCurrentPage", state.currentPage - 1);
                }
                notification.success("Successfully deleted");
            } catch (errors) {
                await commit("errors", errors);
                notification.warning("Oops, something went wrong");
            }
        }
    }
}